import React from 'react'
import { useLocation } from 'react-router-dom'
import { Typography } from '@mui/material'
import styled from 'styled-components'

const HeaderWrapper = styled.div`
	h1 {
		transition: font-size 100ms ease-in-out;
	}
	${props =>
		props.inGame &&
		`
		h1 {
			font-size: 3em;
		}
	`}
`

const Header = _ => {
	const location = useLocation(),
		inGame = /^\/game\/\d+($|\/)/.test(location.pathname),
		roomCode = location.pathname.includes('/game/')
			? location.pathname.replace(/^\/game\/(\d+).*$/, '$1')
			: location.search.includes('?join=')
			? location.search.replace(/^\?join=(\d+).*$/, '$1')
			: '',
		shareLink = e => {
			e.preventDefault()
			if (window.navigator.canShare) {
				window.navigator
					.share({
						title: `Monopoly`,
						text: `Join Monopoly Room ${roomCode}`,
						url: window.location.href.replace(/\?.*$/) + '?join',
					})
					.catch(err => {
						console.error('Error during sharing: ', err)
					})
			} else {
				prompt('Share this link:', window.location.href)
			}
		}

	return (
		<HeaderWrapper $inGame={inGame}>
			<Typography color='#fff' variant='h1' component='h1'>
				Monopoly
				{inGame && (
					<>
						{': '}
						<a href='#' onClick={shareLink} style={{ color: '#fff' }}>
							{roomCode}
						</a>
					</>
				)}
			</Typography>
		</HeaderWrapper>
	)
}

export default Header
